import styled from 'styled-components';
import { s } from './NPL.styles';
import { NumberwithComma, ReportFormatNumber } from '../../../../func/Function';
import { useReportContext } from '../../../../context/DetailContext';
import { INplInfo } from '../../../../service/detail/Detail';

interface IOverViewProps {
  itemList: INplInfo['itemList'];
}

const OverView = (props: IOverViewProps) => {
  const { itemList } = props;
  const { type } = useReportContext();
  return (
    <s.Div>
      <s.Title>채권내 물건별 개요</s.Title>
      {itemList.map((item, index) => (
        <>
          <div>
            <Column>
              <Addr>{item.iaddr}</Addr>
              {/* {type === 'a' ? (
          <SaleNumTag
            style={{
              color: '#D84836',
              backgroundColor: '#ffdbd6',
            }}
          >
            경매
          </SaleNumTag>
        ) : (
          <SaleNumTag
            style={{
              color: '#0C64CE',
              backgroundColor: '#DEEDFF',
            }}
          >
            공매
          </SaleNumTag>
        )}
        <div></div> */}
            </Column>
            <Row>
              <Category>상태</Category>
              <Status>{item.bid}</Status>
            </Row>
            <Row>
              <Category>최저입찰가</Category>
              <Status>{ReportFormatNumber(item.minprice)}</Status>
            </Row>
            <Row>
              <Category>감정가</Category>
              <Status>{ReportFormatNumber(item.appraisedprice)}</Status>
            </Row>
          </div>
        </>
      ))}
    </s.Div>
  );
};

export default OverView;

const InfoContainer = styled.div`
  width: 100%;
  padding: 14px 16px;
  background-color: #f7f8fc;
`;

const Column = styled.div`
  width: 100%;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #f7f8fc;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

const SaleNumTag = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  border-radius: 999px;
  padding: 2px 8px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-weight: 500;
`;

const Addr = styled.span`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 700;
  color: #222222;
`;

const Row = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  background-color: #f7f8fc;

  &:last-child {
    padding-bottom: 14px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

const Category = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: #616161;
`;

const Status = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #222222;
`;
